<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col>
          <h2>Personalizations:</h2>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button size="sm" variant="success" @click="createUberPersonalization">Crear
            Item</b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-table small responsive striped hover :items="personalizations" :fields="tableFields">
            <template #cell(buttons)="data">
              <b-button-group vertical>
                <b-button size="sm" variant="warning"
                  @click="editPersonalization(data.item.id)">Editar</b-button>
              </b-button-group>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </b-container>
    <b-modal id="modal-createUberPersonalization" title="Crear Grupo de Modificadores" size="xl" @ok="createPersonalization">
      <b-row>
        <b-col>
          <p>Aqui puedes crear tus grupos de modificadores (personalizations).</p>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-form-group label="Nombre:">
            <b-form-input v-model="actualItem.title.translations.en" type="text" required></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="External Data (opcional):">
            <b-form-input v-model="actualItem.external_data" type="text" placeholder="Información adicional para referencia interna"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="¿Cuál es el número mínimo de opciones que un cliente debe seleccionar?">
            <b-form-input v-model.number="actualItem.quantity_info.quantity.min_permitted" type="number" min="0" required></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="¿Cuál es el número máximo de opciones que un cliente puede seleccionar?">
            <b-form-input v-model.number="actualItem.quantity_info.quantity.max_permitted" type="number" min="0" required></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="¿Cuántas veces pueden seleccionar los clientes una sola opción?">
            <b-form-input v-model.number="actualItem.quantity_info.quantity.min_permitted_unique" type="number" min="0" required></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <hr>
          <h5>Opciones del Modificador</h5>
          <p>Selecciona los items que estarán disponibles en este grupo de modificadores.</p>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-alert variant="warning" show>
            <strong>Importante:</strong> Para que los items (productos o personalizaciones) aparezcan en esta lista, primero debes:
            <ol class="mb-0 mt-2">
              <li>Crear items en el menú con <code>external_data</code> en formato <code>product::ID</code> para productos</li>
              <li>O crear items con <code>external_data</code> en formato <code>personalization::ID</code> para personalizaciones</li>
            </ol>
            Los items se crean en la sección "Articulos" del menú.
          </b-alert>
        </b-col>
        <b-col md="6" sm="12">
          <b-form-group label="Items del Menú (Productos):">
            <vu-select multiple
              :reduce="(x) => x.value"
              v-model="selectedProducts"
              :options="itemOptions"
              placeholder="Selecciona items del menú que sean productos">
            </vu-select>
          </b-form-group>
        </b-col>
        <b-col md="6" sm="12">
          <b-form-group label="Items del Menú (Personalizaciones):">
            <vu-select multiple
              :reduce="(x) => x.value"
              v-model="selectedPersonalizations"
              :options="personalizationItemOptions"
              placeholder="Selecciona items del menú que sean personalizaciones">
            </vu-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="actualItem.modifier_options.length > 0">
        <b-col cols="12">
          <b-alert variant="info" show>
            <strong>Opciones seleccionadas ({{ actualItem.modifier_options.length }}):</strong>
            <ul class="mb-0 mt-2">
              <li v-for="option in actualItem.modifier_options" :key="option.id">
                {{ getOptionLabel(option) }}
              </li>
            </ul>
          </b-alert>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "UberPersonalizations",
  data() {
    return {
      products: [],
      productOptions: [],
      personalizations: [],
      items: [],
      itemOptions: [],
      personalizationItemOptions: [],
      systemPersonalizations: [],
      personalizationOptions: [],
      selectedProducts: [],
      selectedPersonalizations: [],
      actualItem: {
        id: "",
        title: {
          translations: {
            en: ""
          }
        },
        external_data: "",
        quantity_info: {
          quantity: {
            max_permitted: 1,
            min_permitted:1,
            is_min_permitted_optional:false,
            min_permitted_unique:1
          },
          overrides: []
        },
        modifier_options: [],
      },
      search: "",
      tableFields: [
        { key: "title.translations.en", label: "Titulo" },
        { key: "modifier_options", label: "Opciones", formatter: (value) => value ? value.length : 0 },
        { key: "buttons", label: "" }
      ]
    };
  },
  mounted() {
    this.getAllPersonalizations();
    this.getAllProducts();
    this.getAllItems();
    this.getAllSystemPersonalizations();
  },
  watch: {
    selectedProducts() {
      this.updateModifierOptions();
    },
    selectedPersonalizations() {
      this.updateModifierOptions();
    }
  },
  methods: {
    createUberPersonalization() {
      this.resetactualPersonalization()
      this.$bvModal.show("modal-createUberPersonalization")
    },
    getAllProducts() {
      let that = this;
      axios
        .get("/products")
        .then(function (response) {
          that.products = response.data;
          let persfil = response.data
            .filter((pers) => {
              return pers.status;
            })
            .map((pers) => {
              return { id: pers.id.toString(), label: pers.clave + " - " + pers.ndescription };
            });
          let persfils = [{ id: null, label: "NINGUNO" }]
          persfils.push(...persfil)
          that.productOptions = persfils;
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    getAllItems() {
      let that = this;
      axios
        .get("/uber/mastermenu/" + this.$route.params.id + "/items")
        .then(function (response) {
          that.items = response.data;

          // Filter items that are products (external_data starts with "product::")
          let productItems = response.data
            .filter(item => item.external_data && item.external_data.startsWith("product::"))
            .map((item) => {
              return {
                id: item.id,
                label: item.title.translations.en + " (Producto)",
                value: { type: "ITEM", id: item.id },
                external_data: item.external_data
              };
            });
          that.itemOptions = productItems;

          // Filter items that are personalizations (external_data starts with "personalization::")
          let personalizationItems = response.data
            .filter(item => item.external_data && item.external_data.startsWith("personalization::"))
            .map((item) => {
              return {
                id: item.id,
                label: item.title.translations.en + " (Personalización)",
                value: { type: "ITEM", id: item.id },
                external_data: item.external_data
              };
            });
          that.personalizationItemOptions = personalizationItems;
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    getAllSystemPersonalizations() {
      let that = this;
      axios
        .get("/personalizations")
        .then(function (response) {
          that.systemPersonalizations = response.data;
          let persList = response.data
            .filter((pers) => {
              return pers.status;
            })
            .map((pers) => {
              return {
                id: pers.id,
                label: pers.id + " - " + pers.name,
                value: { type: "ITEM", id: pers.id.toString() }
              };
            });
          that.personalizationOptions = persList;
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    updateModifierOptions() {
      // Combine selected products and personalizations into modifier_options
      let options = [];

      // Add selected products (items from menu)
      if (this.selectedProducts && this.selectedProducts.length > 0) {
        options.push(...this.selectedProducts);
      }

      // Add selected personalizations
      if (this.selectedPersonalizations && this.selectedPersonalizations.length > 0) {
        options.push(...this.selectedPersonalizations);
      }

      this.actualItem.modifier_options = options;
    },
    getOptionLabel(option) {
      // Find the label for the option
      if (option.type === "ITEM") {
        // Check if it's a menu item
        const item = this.items.find(i => i.id === option.id);
        if (item) {
          return `[Item] ${item.title.translations.en}`;
        }

        // Check if it's a personalization
        const pers = this.systemPersonalizations.find(p => p.id.toString() === option.id);
        if (pers) {
          return `[Personalización] ${pers.name}`;
        }
      }
      return `${option.type}: ${option.id}`;
    },
    editPersonalization(id) {
      let that = this;
      this.actualItem.id = id;
      axios
        .get("/uber/mastermenu/" + this.$route.params.id + "/modifiergroup/" + this.actualItem.id)
        .then(function (response) {
          that.actualItem = response.data;

          // Populate selectedProducts and selectedPersonalizations from modifier_options
          that.selectedProducts = [];
          that.selectedPersonalizations = [];

          if (that.actualItem.modifier_options && that.actualItem.modifier_options.length > 0) {
            that.actualItem.modifier_options.forEach(option => {
              if (option.type === "ITEM") {
                // Find the item in the items array
                const menuItem = that.items.find(i => i.id === option.id);
                if (menuItem && menuItem.external_data) {
                  // Check if it's a product or personalization based on external_data
                  if (menuItem.external_data.startsWith("product::")) {
                    that.selectedProducts.push(option);
                  } else if (menuItem.external_data.startsWith("personalization::")) {
                    that.selectedPersonalizations.push(option);
                  }
                }
              }
            });
          }

          that.$bvModal.show("modal-createUberPersonalization");
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    getAllPersonalizations() {
      let that = this;
      axios
        .get("/uber/mastermenu/" + this.$route.params.id + "/modifiergroups")
        .then(function (response) {
          that.personalizations = response.data;
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    createPersonalization(bvModalEvent) {
      // Prevent modal from closing
      bvModalEvent.preventDefault();

      // Validation
      const numOptions = this.actualItem.modifier_options ? this.actualItem.modifier_options.length : 0;
      const minPermittedUnique = this.actualItem.quantity_info?.quantity?.min_permitted_unique ?? 0;
      const minPermitted = this.actualItem.quantity_info?.quantity?.min_permitted ?? 0;
      const maxPermitted = this.actualItem.quantity_info?.quantity?.max_permitted ?? 0;

      // Validate title is not empty
      if (!this.actualItem.title?.translations?.en || this.actualItem.title.translations.en.trim() === "") {
        this.makeToast("Error de Validación", "El nombre del grupo de modificadores es requerido.", "warning");
        return;
      }

      // Validate that there are options selected
      if (numOptions === 0) {
        this.makeToast("Error de Validación", "Debes seleccionar al menos una opción de modificador (producto o personalización).", "warning");
        return;
      }

      // Validate non-negative values (cannot be negative)
      if (minPermitted < 0) {
        this.makeToast("Error de Validación", "El mínimo permitido no puede ser negativo.", "warning");
        return;
      }

      if (maxPermitted < 0) {
        this.makeToast("Error de Validación", "El máximo permitido no puede ser negativo.", "warning");
        return;
      }

      if (minPermittedUnique < 0) {
        this.makeToast("Error de Validación", "El número de opciones únicas no puede ser negativo.", "warning");
        return;
      }

      // Validate maxPermitted >= minPermitted
      if (maxPermitted < minPermitted) {
        this.makeToast("Error de Validación",
          `El máximo permitido (${maxPermitted}) no puede ser menor que el mínimo permitido (${minPermitted}).`,
          "warning");
        return;
      }

      // Validate minPermittedUnique is not greater than number of options
      if (minPermittedUnique > numOptions) {
        this.makeToast("Error de Validación",
          `El número de opciones únicas requeridas (${minPermittedUnique}) no puede ser mayor que el número total de opciones seleccionadas (${numOptions}).`,
          "warning");
        return;
      }

      // Validate that minPermitted can actually be satisfied
      // Uber validation: if minPermitted > 0, there must be at least that many options available
      if (minPermitted > 0 && numOptions === 0) {
        this.makeToast("Error de Validación",
          `No puedes requerir un mínimo de ${minPermitted} selecciones cuando no hay opciones disponibles. Agrega opciones o establece el mínimo en 0.`,
          "warning");
        return;
      }

      // CRITICAL Uber validation: minPermitted must be >= minPermittedUnique
      // This is the validation that was failing!
      if (minPermittedUnique > 0 && minPermitted < minPermittedUnique) {
        this.makeToast("Error de Validación",
          `El mínimo permitido (${minPermitted}) debe ser al menos igual al número de opciones únicas requeridas (${minPermittedUnique}). ` +
          `Si requieres ${minPermittedUnique} opciones únicas, el cliente debe seleccionar al menos ${minPermittedUnique} items en total.`,
          "warning");
        return;
      }

      let that = this;
      let verb = ""
      if (this.actualItem.id.length > 0) {
        verb = "PUT"
      } else {
        verb = "POST"
      }
      console.log(verb)
      axios({ method: verb, url: "/uber/mastermenu/" + this.$route.params.id + "/modifiergroup", data: this.actualItem })
        .then(function (response) {
          that.actualItem = response.data;
          that.getAllPersonalizations()
          that.resetactualPersonalization()
          // Close the modal after successful save
          that.$bvModal.hide("modal-createUberPersonalization");
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    getPersonalization() {
      let that = this;
      axios
        .get("/uber/mastermenu/" + this.$route.params.id + "/personalization/" + this.actualItem.id)
        .then(function (response) {
          that.actualItem = response.data;
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    resetactualPersonalization() {
      this.actualItem = {
        id: "",
        title: {
          translations: {
            en: ""
          }
        },
        external_data: "",
        quantity_info: {
          quantity: {
            max_permitted: 1,
            min_permitted: 1,
            is_min_permitted_optional: false,
            min_permitted_unique: 1
          },
          overrides: []
        },
        modifier_options: [],
      };
      this.selectedProducts = [];
      this.selectedPersonalizations = [];
    },
    makeToast(title, content, variant) {
      this.$bvToast.toast(content, {
        title,
        variant,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
  },
};
</script>
  